import React, { JSX } from 'react';
import { Link } from 'react-router-dom';
import useRealm from '../../../hooks/realm/UseRealm';
import useMenu from '../../../hooks/UseMenu';
import maxLength from '../../../util/MaxLength';
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react';

interface Props {
  toAdmin: boolean;
  title: string;
  description: string;
}

export default function SwitchUserContext({ toAdmin, title, description }: Props): JSX.Element {
  const { realm } = useRealm();
  const { isOpen } = useMenu();

  const link = toAdmin ? `/realm/${realm?.publicKey}/admin/stats` : `/realm/${realm?.publicKey}`;
  const trimmedDescription = maxLength(description, 24);

  // Bail out when the user is not an admin
  if (!realm?.isAdmin || !isOpen) {
    return <></>;
  }

  return (
    <Link to={link} className='flex flex-col px-5 pt-10 whitespace-nowrap'>
      <div className='flex items-center text-zinc-50'>
        {!toAdmin && <CaretLeftIcon />}
        <span>{title}</span>
        {toAdmin && <CaretRightIcon />}
      </div>

      <span className='text-xs text-gray-400 pt-1'>{trimmedDescription}</span>
    </Link>
  );
}
